/* CSS */
import "@js/parts/css";
import "lenis/dist/lenis.css";

/* Non-alpine JS */
import Lenis from "lenis";

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import logoCarousel from "@js/parts/logoCarousel";
import navPrimary from "@js/parts/navPrimary";
import mouseFollower from "@js/parts/mouseFollower";
import scrollLightSweep from "@js/parts/scrollLightSweep";
import slider from "@js/parts/slider";
import tilt from "@js/parts/tilt";
import counter from "@js/parts/counter";
import countUp from "@js/parts/countUp";
import consent from "@js/parts/consent";
import accessibleVideo from "@js/parts/accessibleVideo";
import { prefersReducedMotion } from "@js/parts/prefersReducedMotion";

/* Register components */
Alpine.data("logoCarousel", logoCarousel);
Alpine.data("navPrimary", navPrimary);
Alpine.data("mouseFollower", mouseFollower);
Alpine.data("scrollLightSweep", scrollLightSweep);
Alpine.data("slider", slider);
Alpine.data("tilt", tilt);
Alpine.data("counter", counter);
Alpine.data("countUp", countUp);
Alpine.data("consent", consent);
Alpine.data("accessibleVideo", accessibleVideo);

Alpine.plugin(intersect);
Alpine.plugin(focus);

Alpine.directive('highlight', (el, { expression }, { effect, cleanup }) => {
  effect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.classList.add('x-highlight');
          observer.disconnect();
        }
      });
    });

    observer.observe(el);
  });

  cleanup(() => {
    el.classList.remove('x-highlight');
  });
});

Alpine.start();

/* Smooth scroll */
if (!prefersReducedMotion()) {
  new Lenis({
    autoRaf: true,
  });
}

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}
